export const platformSecurityLevels = Object.freeze([
    {
        number: "01",
        shortTitleKey: "main.landing.capabilities.security.levels.registration.shortTitle",
        titleKey: "main.landing.capabilities.security.levels.registration.title",
        descriptionKey: "main.landing.capabilities.security.levels.registration.description",
    },
    {
        number: "02",
        shortTitleKey: "main.landing.capabilities.security.levels.legal.shortTitle",
        titleKey: "main.landing.capabilities.security.levels.legal.title",
        descriptionKey: "main.landing.capabilities.security.levels.legal.description",
    },
    {
        number: "03",
        shortTitleKey: "main.landing.capabilities.security.levels.finance.shortTitle",
        titleKey: "main.landing.capabilities.security.levels.finance.title",
        descriptionKey: "main.landing.capabilities.security.levels.finance.description",
    },
    {
        number: "04",
        shortTitleKey: "main.landing.capabilities.security.levels.risks.shortTitle",
        titleKey: "main.landing.capabilities.security.levels.risks.title",
        descriptionKey: "main.landing.capabilities.security.levels.risks.description",
    },
    {
        number: "05",
        shortTitleKey: "main.landing.capabilities.security.levels.trip.shortTitle",
        titleKey: "main.landing.capabilities.security.levels.trip.title",
        descriptionKey: "main.landing.capabilities.security.levels.trip.description",
    },
]);
